/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.storageDamageMaster.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/storageDamageMaster/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
